import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionCardProps {
  title: string;
  /** Optional "Ver …" link shown top-right. */
  action?: { label: string; to: string };
  children: ReactNode;
  className?: string;
}

export function SectionCard({
  title,
  action,
  children,
  className,
}: SectionCardProps): JSX.Element {
  return (
    <section
      className={`rounded-admin-lg border border-admin-border bg-admin-surface p-5 ${className ?? ''}`}
    >
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-base">{title}</h2>
        {action ? (
          <Link
            to={action.to}
            className="text-sm font-medium text-admin-accent hover:text-admin-primary"
          >
            {action.label}
          </Link>
        ) : null}
      </div>
      {children}
    </section>
  );
}
